// ════════════════════════════════════════════════════════════════════════════
// Attribution de l'huile produite — règle unique, partagée par tous les parcours.
//
// PRINCIPE : l'huile d'une prestation appartient au CLIENT qui a apporté les olives.
// Un total d'huile MESURÉ ne peut donc être réparti qu'entre des lots réellement
// triturés ensemble ET appartenant au même client. Les achats d'olives (fournisseurs)
// appartiennent à l'huilerie : ils forment un seul groupe.
//
// Arrondi : au gramme (3 décimales). Le dernier lot reçoit le reste exact, donc la
// somme des quantités attribuées est TOUJOURS égale au total saisi.
// ════════════════════════════════════════════════════════════════════════════

// Clé de groupe d'huile d'un lot (réception ou ligne d'OF).
export const cleGroupeHuile = (l) =>
  l?.parcours === 'client' ? `client:${l.tiersId ?? l.tiers ?? l.id}` : 'fournisseurs';

// Clients distincts présents dans une sélection de lots.
export const clientsDistincts = (lots) => [
  ...new Set((lots ?? []).filter((l) => l?.parcours === 'client').map((l) => l.tiersId ?? l.tiers ?? l.id)),
];

export function repartirProrata(total, lots) {
  const liste = (lots ?? []).filter(Boolean);
  const t = Number(total);
  if (!liste.length) return { error: 'Cochez les lots réellement triturés ensemble.' };
  if (!Number.isFinite(t) || t <= 0) return { error: 'Saisissez le total d’huile mesuré (kg).' };
  const clients = clientsDistincts(liste);
  if (clients.length > 1)
    return {
      error:
        'Répartition refusée : un total d’huile mesuré ne se partage jamais entre des clients différents. Saisissez un total par passage réellement trituré ensemble.',
    };
  if (clients.length === 1 && liste.some((l) => l.parcours && l.parcours !== 'client'))
    return { error: 'Répartition refusée : une prestation client et un achat d’olives ne partagent pas le même total d’huile.' };
  const poids = liste.map((l) => Number(l.poidsNet));
  if (poids.some((p) => !Number.isFinite(p) || p <= 0))
    return { error: 'Poids net manquant ou invalide sur un lot coché : répartition refusée.' };
  const somme = poids.reduce((s, p) => s + p, 0);
  if (!(somme > 0)) return { error: 'Poids total nul : répartition impossible.' };
  const parts = liste.map((l, i) => ({ id: l.id, huile: Number(((t * poids[i]) / somme).toFixed(3)) }));
  const cumul = Number(parts.slice(0, -1).reduce((s, p) => s + p.huile, 0).toFixed(3));
  parts[parts.length - 1] = { ...parts[parts.length - 1], huile: Number((t - cumul).toFixed(3)) };
  if (parts.some((p) => p.huile <= 0))
    return { error: 'Répartition impossible : un lot recevrait une quantité nulle ou négative.' };
  return { error: null, parts, total: Number(t.toFixed(3)), poidsTotal: Number(somme.toFixed(3)) };
}
